import axios from 'axios';

let prefix = "/product"

const ProductTranslationApi = {

	// Get all translations for a product
	getProductTranslations(productId) {
		return axios.get(`${prefix}/${productId}/translations`)
	},

	// Get a specific translation by locale
	getProductTranslationByLocale(productId, locale) {
		return axios.get(`${prefix}/${productId}/translations/${locale}`)
	},

	// Create or update a translation
	saveProductTranslation(productId, payload) {
		return axios.post(`${prefix}/${productId}/translations`, payload)
	},

	// Delete a translation
	deleteProductTranslation(productId, locale) {
		return axios.delete(`${prefix}/${productId}/translations/${locale}`)
	},

}

export default ProductTranslationApi;
